import { Sanity$Image } from '@otovo/shared/types/sanityImage';
import { Sanity$RowContent } from '@otovo/shared/types/sanityTypes';

import SanityImage from '@otovo/shared/components/Sanity/SanityImage';

import PortableText from '@otovo/shared/components/Sanity/PortableTextComponents';
import SectionWrapper from '../../SectionWrapper';
import { RowContext } from '../../types';

type Props = {
  content: Sanity$RowContent[];
  context: RowContext;
};

const BlockContentRow = ({ content, context }: Props) => {
  const { isWhiteRow, version = 'legacy' } = context;

  const image: Sanity$Image = content?.find((block) => block._type === 'image');

  if (!image) {
    return (
      <SectionWrapper>
        <div className="align-center col-span-10 col-start-2 flex flex-col justify-center xl:col-span-8 xl:col-start-3">
          <PortableText value={content} />
        </div>
      </SectionWrapper>
    );
  }

  if (version === 'v2025') {
    return (
      <section className="color-scheme-light relative mx-4 my-16 max-w-8xl justify-center gap-0 rounded-md bg-surface p-8 md:mx-6 md:my-20 lg:mx-16 lg:my-24 lg:grid lg:grid-cols-12 lg:p-16 2xl:mx-auto">
        <div className="col-span-5 prose mb-12 lg:mb-0 prose-ul:p-0">
          <PortableText value={content} />
        </div>
        <div className="col-span-6 col-start-7 w-full overflow-hidden">
          <SanityImage
            className="aspect-square w-full rounded-xl sm:aspect-auto"
            equalizeImageHeight
            image={image}
            sizes="(max-width: 767px) 80vw, 480px"
          />
        </div>
      </section>
    );
  }

  return (
    <SectionWrapper gap="gap-0" colorScheme={isWhiteRow ? 'white' : 'dark'}>
      <div className="col-span-5 mb-12 lg:mb-0">
        <PortableText value={content} />
      </div>
      <div className="col-span-6 col-start-7 w-full overflow-hidden">
        <SanityImage
          className="w-full rounded-xl"
          equalizeImageHeight
          image={image}
          sizes="(max-width: 767px) 80vw, 480px"
        />
      </div>
    </SectionWrapper>
  );
};

export default BlockContentRow;
